const States = {
  initial: 'initial',
  warning: 'warning',
  scanning: 'scanning',
  completed: 'completed',
} as const

type State = (typeof States)[keyof typeof States]

export const Oval = { States }

export type OvalState = State

export type MeasurementOvalNormalizedFrame = {
  x: number
  y: number
  width: number
  height: number
}

export type OvalLayout = {
  width: number
  height: number
  /** Design-to-screen scale factor (already includes the scale multiplier). */
  scale: number
  /** SVG transform string mapping design coordinates to screen coordinates. */
  transform: string
  /** Screen-space Y of the oval path's top edge. */
  ovalTop: number
}
